import React from 'react';
import Post from './pages/post.js'
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Post />
      </header>
    </div>
  );
}

export default App;
